import { validateEmail } from "Source/globalFunction";
import { validatCloudCFOEmail, validatInputEmail } from "../email";

/**
 * creates and returns a validation rule object that
 * is used by useForm hook to validate the form inputs
 *
 * @param {string} ruleName - name of the validation rule
 * @param {string} errorMessage - messadge to display
 * @param {function} validateFunc - validation function
 */
export function createValidationRule(ruleName, errorMessage, validateFunc) {
  return {
    name: ruleName,
    message: errorMessage,
    validate: validateFunc
  };
}

export function requiredRule(inputName) {
  return createValidationRule(
    "required",
    `${inputName} required`,
    (inputValue) => inputValue.length !== 0
  );
}

export function minLengthRule(inputName, minCharacters) {
  return createValidationRule(
    "minLength",
    `${inputName} should contain atleast ${minCharacters} characters`,
    (inputValue) => inputValue.length >= minCharacters
  );
}

export function maxLengthRule(inputName, maxCharacters) {
  return createValidationRule(
    "minLength",
    `Must not exceed 100 characters`,
    (inputValue) => inputValue.length <= maxCharacters
  );
}

export function validEmailRule(inputName, suffix = null) {
  return createValidationRule(
    "isValidEmail",
    'Invalid Email Address',
    (inputValue) => suffix
      ? validateEmail(`${inputValue}@${suffix}`)
      : validateEmail(inputValue)
  );
}

export function validCFOEmailRule(inputName, suffix = null) {
  return createValidationRule(
    "isValidEmail",
    'Invalid Email Address',
    (inputValue) => suffix
      ? validatCloudCFOEmail(`${inputValue}@${suffix}`)
      : validatCloudCFOEmail(inputValue)
  );
}

export function validEmailInputRule(inputName, suffix = null) {
  return createValidationRule(
    "isValidEmail",
    'Invalid Email Address',
    (inputValue) => suffix
      ? validatInputEmail(`${inputValue}@${suffix}`)
      : validatInputEmail(inputValue)
  );
}
